import { createModel } from '@rematch/core';
import { Allergy } from '../../models/allergy';
import { PHVType } from '../../models/phv';
import { storeByIMPSId } from '../../utils/converter';
import {
    getAppointmentAllergies,
    getLatestAllergies
} from '../../apis/allergy';

export interface State {
    allIds: number[];
    byId: Dictionary<Allergy>;
    loading: Dictionary<boolean>;
}

export const allergies = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<Allergy>>,
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                const byId = {
                    ...state.byId,
                    ...storeByIMPSId(data)
                };
                return {
                    ...state,
                    allIds: Object.keys(byId)
                        .sort((a, b) => (byId[a]!.onsetDate || '') > (byId[b]!.onsetDate || '') ? 1 : -1)
                        .map(x => +x),
                    byId: byId,
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: dispatch => ({
        async getLatestAllergiesAsync() {
            const {
                compositeAllergies,
                phvs
            } = dispatch;
            this.loading('getLatestAllergiesAsync', true);
            try {
                const data = await getLatestAllergies();
                this.update(data, 'getLatestAllergiesAsync');

                // Collect related data
                if (data) {
                    compositeAllergies.getCompositeAllergiesAsync(data.map(x => x.allergyId));
                    phvs.getPHVsAsync(PHVType.Reaction);
                }
            } catch (e) {
                window.console.log(e);
                this.loading('getLatestAllergiesAsync', false);
            }
        },
        async getAppointmentAllergiesAsync(appointment: number) {
            const {
                compositeAllergies,
                phvs
            } = dispatch;
            this.loading('getAppointmentAllergiesAsync', true);
            try {
                const data = await getAppointmentAllergies(appointment);
                this.update(data, 'getAppointmentAllergiesAsync');

                // Collect related data
                if (data) {
                    compositeAllergies.getCompositeAllergiesAsync(data.map(x => x.allergyId));
                    phvs.getPHVsAsync(PHVType.Reaction);
                }
            } catch (e) {
                window.console.log(e);
                this.loading('getAppointmentAllergiesAsync', false);
            }
        }
    })
});
